import { ComponentProps, ReactNode } from "react";
import { cn } from "@/lib/utils";

interface DataSurfaceProps extends ComponentProps<"section"> {
  title?: string;
  description?: string;
  action?: ReactNode;
}

export function DataSurface({
  title,
  description,
  action,
  className,
  children,
  ...props
}: DataSurfaceProps) {
  return (
    <section
      className={cn("overflow-hidden border border-line bg-card", className)}
      {...props}
    >
      {(title || description || action) && (
        <div className="flex min-h-14 items-center justify-between gap-4 border-b border-line px-4 py-3 md:px-5">
          <div className="min-w-0">
            {title && <h2 className="text-base font-semibold text-text">{title}</h2>}
            {description && <p className="text-sm text-muted">{description}</p>}
          </div>
          {action && <div className="shrink-0">{action}</div>}
        </div>
      )}
      <div className="divide-y divide-line">{children}</div>
    </section>
  );
}
